document.addEventListener('DOMContentLoaded', () => {
  document.getElementById("MainContent").addEventListener('click', () => {
    if (document.body.classList.contains('header-open')) {
      var headerDropdowns = document.querySelectorAll('.header-dropdown')
      for (let index = 0; index < headerDropdowns.length; index++) {
        headerDropdowns[index].classList.remove('active')
      }
      document.body.classList.remove('js-my-cart-open');
      document.body.classList.remove('header-open');
      var mainContent = document.getElementById('MainContent')
      var headerWithPadding = 0
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    }
  })
})




// Header Dropdowns
function closeSizeguide() {
  document.querySelector('.sizeguide-dropdown').classList.remove('active')
  document.getElementById('MainContent').style="margin-top: 0;"
  document.body.classList.remove('header-open');
}


function openInformation() {
  var headerDropdowns = document.querySelectorAll('.header-dropdown')
  for (let index = 0; index < headerDropdowns.length; index++) {
    const element = headerDropdowns[index];
    if (element.classList.contains('information-dropdown') && element.classList.contains('active')) {
      document.body.classList.remove('header-open');
      document.querySelector('.information-dropdown').classList.remove('active')
      var mainContent = document.getElementById('MainContent')
      var headerWithPadding = 0
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else if (element.classList.contains('information-dropdown')) {
      document.body.classList.add('header-open');
      document.querySelector('.information-dropdown').classList.add('active')
      var mainContent = document.getElementById('MainContent')
      var headerHeight = document.querySelector('.information-dropdown .grid-auto').offsetHeight
      var headerWithPadding = headerHeight + 125
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else {
      element.classList.remove('active')
    }
  }
  document.body.classList.remove('js-my-cart-open'); document.body.classList.remove('size-select-open');
  if (document.querySelector('.add-to-cart-container')) {
    document.querySelector('.add-to-cart-container').classList.remove('active')
    }

}

function closeInformation () {
  document.querySelector('.information-dropdown').classList.remove('active')
  document.getElementById('MainContent').style="margin-top: 0;"
  document.body.classList.remove('header-open');
}

function openCategories() {
  var headerDropdowns = document.querySelectorAll('.header-dropdown')
  for (let index = 0; index < headerDropdowns.length; index++) {
    const element = headerDropdowns[index];
    if (element.classList.contains('categories-dropdown') && element.classList.contains('active')) {
      document.body.classList.remove('header-open');
      document.querySelector('.categories-dropdown').classList.remove('active')
      var mainContent = document.getElementById('MainContent')
      var headerWithPadding = 0
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else if (element.classList.contains('categories-dropdown')) {
      document.body.classList.add('header-open');
      document.querySelector('.categories-dropdown').classList.add('active')
      var mainContent = document.getElementById('MainContent')
      var headerHeight = document.querySelector('.categories-dropdown .grid-auto').offsetHeight
      var headerWithPadding = headerHeight + 125
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else {
      element.classList.remove('active')
    }
  }
  document.body.classList.remove('js-my-cart-open'); document.body.classList.remove('size-select-open');
  if (document.querySelector('.add-to-cart-container')) {
    document.querySelector('.add-to-cart-container').classList.remove('active')
    }

}

function closeCategories () {
  document.querySelector('.categories-dropdown').classList.remove('active')
  document.getElementById('MainContent').style="margin-top: 0;"
  document.body.classList.remove('header-open');
}

function openFilters() {
  var headerDropdowns = document.querySelectorAll('.header-dropdown')
  for (let index = 0; index < headerDropdowns.length; index++) {
    const element = headerDropdowns[index];
    if (element.classList.contains('filters-dropdown') && element.classList.contains('active')) {
      document.body.classList.remove('header-open');
      document.querySelector('.filters-dropdown').classList.remove('active')
      var mainContent = document.getElementById('MainContent')
      var headerWithPadding = 0
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else if (element.classList.contains('filters-dropdown')) {
      document.body.classList.add('header-open');
      document.querySelector('.filters-dropdown').classList.add('active')
      var mainContent = document.getElementById('MainContent')
      var headerHeight = document.querySelector('.filters-dropdown .grid-auto').offsetHeight
      var headerWithPadding = headerHeight + 125
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else {
      element.classList.remove('active')
    }
  }
  document.body.classList.remove('js-my-cart-open'); document.body.classList.remove('size-select-open');
  if (document.querySelector('.add-to-cart-container')) {
    document.querySelector('.add-to-cart-container').classList.remove('active')
    }

}

function closeFilters () {
  document.querySelector('.filters-dropdown').classList.remove('active')
  document.getElementById('MainContent').style="margin-top: 0;"
  document.body.classList.remove('header-open');
}

function openCampaigns () {
  var headerDropdowns = document.querySelectorAll('.header-dropdown')
  for (let index = 0; index < headerDropdowns.length; index++) {
    const element = headerDropdowns[index];
    if (element.classList.contains('campaigns-dropdown') && element.classList.contains('active')) {
      document.body.classList.remove('header-open');
      document.querySelector('.campaigns-dropdown').classList.remove('active')
      var mainContent = document.getElementById('MainContent')
      var headerWithPadding = 0
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else if (element.classList.contains('campaigns-dropdown')) {
      document.body.classList.add('header-open');
      document.querySelector('.campaigns-dropdown').classList.add('active')
      var mainContent = document.getElementById('MainContent')
      var headerHeight = document.querySelector('.campaigns-dropdown .grid-auto').offsetHeight
      var headerWithPadding = headerHeight + 125
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else {
      element.classList.remove('active')
    }
  }
  document.body.classList.remove('js-my-cart-open'); document.body.classList.remove('size-select-open');
  if (document.querySelector('.add-to-cart-container')) {
    document.querySelector('.add-to-cart-container').classList.remove('active')
    }

}

function closeCampaigns() {
  document.querySelector('.campaigns-dropdown').classList.remove('active')
  document.getElementById('MainContent').style="margin-top: 0;"
  document.body.classList.remove('header-open');
}

function toggleSizeGuide() {
  var tables = document.querySelectorAll('.size-guide-table')
  for (let index = 0; index < tables.length; index++) {
    const element = tables[index];
    element.classList.toggle('active')
  }
}

function openSearch() {
  var headerDropdowns = document.querySelectorAll('.header-dropdown')
  for (let index = 0; index < headerDropdowns.length; index++) {
    const element = headerDropdowns[index];
    if (element.classList.contains('search-dropdown') && element.classList.contains('active')) {
      document.body.classList.remove('header-open');
      document.querySelector('.search-dropdown').classList.remove('active')
      var mainContent = document.getElementById('MainContent')
      var headerWithPadding = 0
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else if (element.classList.contains('search-dropdown')) {
      document.body.classList.add('header-open');
      document.querySelector('.search-dropdown').classList.add('active')
      var mainContent = document.getElementById('MainContent')
      var headerHeight = document.querySelector('.search-dropdown .grid-auto').offsetHeight
      var headerWithPadding = headerHeight + 125
      mainContent.style = "margin-top:" + headerWithPadding + "px;"
    } else {
      element.classList.remove('active')
    }
  }
  document.body.classList.remove('js-my-cart-open'); document.body.classList.remove('size-select-open');
  if(document.querySelector('.add-to-cart-container')) {
    document.querySelector('.add-to-cart-container').classList.remove('active')
}
    
}

function closeSearch () {
  document.querySelector('.search-dropdown').classList.remove('active')
  document.getElementById('MainContent').style="margin-top: 0;"
  document.body.classList.remove('header-open');
}



// Mobile Menu 

function openMobileMenu () {
  let mobileMenu = document.getElementById("mobile-menu")
  mobileMenu.classList.add('active')
}

function closeMobileMenu () {
  let mobileMenu = document.getElementById("mobile-menu")
  mobileMenu.classList.remove('active')
}

function openMobileDropdown (element) {
  let mobileTriggers = document.querySelectorAll('.mobile-dropdown-trigger')

  for (let index = 0; index < mobileTriggers.length; index++) {
    let trigger = mobileTriggers[index]
    if (trigger == element) {
      element.classList.toggle('active')
    } else {
      trigger.classList.remove('active')
    }
  }
}

function openMobileFilter () {
  openMobileMenu()

  let mobileTriggers = document.querySelectorAll('.mobile-dropdown-trigger')

  for (let index = 0; index < mobileTriggers.length; index++) {
    let trigger = mobileTriggers[index]
    if (trigger.id == "filter-trigger") {
      trigger.classList.add('active')
    } else {
      trigger.classList.remove('active')
    }
  }
}



// window.onscroll = () => {
//   document.getElementById('MainContent').style="margin-top: 0;"
//   document.body.classList.remove('header-open');
//   var headerDropdowns = document.querySelectorAll('.header-dropdown')
//   for (let index = 0; index < headerDropdowns.length; index++) {
//     const element = headerDropdowns[index];
//     element.classList.remove('active')
//   }

//   document.body.classList.remove('js-my-cart-open')

 
// }; 
